"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
const Wrapper = _styledComponents.default.div`
  clear: both;
  width: 100%;
  max-width: 100%;
  text-align: center;
`;
function Iframe(props) {
  const {
    data: {
      src,
      url,
      height,
      width
    },
    ...rest
  } = props;
  const overrideHeight = Number(height);
  const overrideWidth = Number(width);
  let attrWidth = 16;
  let attrHeight = 9;
  if (overrideHeight > 0 && overrideWidth > 0) {
    attrWidth = overrideWidth;
    attrHeight = overrideHeight;
  }
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement("amp-iframe", (0, _extends2.default)({
    width: attrWidth,
    height: attrHeight,
    layout: 'responsive',
    sandbox: 'allow-scripts allow-same-origin allow-forms allow-popups',
    frameBorder: '0',
    src: src || url
  }, rest), /*#__PURE__*/_react.default.createElement("p", {
    placeholder: ''
  }, "Loading....")));
}
Iframe.propTypes = {
  data: _propTypes.default.any.isRequired
};
var _default = exports.default = Iframe;